import { notify } from 'utils/reduxUtils';

export const types = {
  UPDATE_BUSINESS_NAME_ERROR: 'companyName/UPDATE_BUSINESS_NAME_ERROR',
  UPDATE_BUSINESS_NAME_REQUEST: 'companyName/UPDATE_BUSINESS_NAME_REQUEST',
  UPDATE_BUSINESS_NAME_SUCCESS: 'companyName/UPDATE_BUSINESS_NAME_SUCCESS',
};

export const updateCompanyName = {
  error: notify(
    (error) => ({
      type: types.UPDATE_BUSINESS_NAME_ERROR,
      payload: error,
    }),
    'Failed to update company name',
  ),
  request: ({ businessName }) => ({
    type: types.UPDATE_BUSINESS_NAME_REQUEST,
    payload: { businessName },
  }),
  success: () => ({
    type: types.UPDATE_BUSINESS_NAME_SUCCESS,
  }),
};
